import { Box, styled } from '@mui/material';

export const SBar = styled(Box)(({ theme }) => ({
  background: theme.palette.primary[50],
  borderRadius: 4,
  height: 4,
  overflow: 'hidden',
  width: '100%',
}));

export const SFill = styled(Box)(({ theme }) => ({
  background: theme.palette.primary[500],
  borderRadius: 4,
  height: '100%',
}));
